module.exports = __webpack_public_path__ + "static/media/office.66904227.png";